import { render, staticRenderFns } from "./submissions-notification-message.vue?vue&type=template&id=bc6ffede&scoped=true&"
import script from "./submissions-notification-message.vue?vue&type=script&lang=ts&"
export * from "./submissions-notification-message.vue?vue&type=script&lang=ts&"
import style0 from "./submissions-notification-message.vue?vue&type=style&index=0&id=bc6ffede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6ffede",
  null
  
)

export default component.exports